import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { templateGalleryMessages } from '@atlaskit/editor-common/messages';
import {
	QuickInsertMenuItem,
	type OnSelectContext,
} from '@atlaskit/editor-common/quick-insert/menu-item';
import { useQuickInsertContext } from '@atlaskit/editor-common/quick-insert/use-quick-insert-context';
import TemplateIcon from '@atlaskit/icon-lab/core/template';

import { openTemplateGallerySafely } from '../../utils/openTemplateGallery';

type Props = {
	onOpenTemplateGallery: () => void;
};

export const TemplateGalleryQuickInsertMenuItem = ({
	onOpenTemplateGallery,
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { isOffline } = useQuickInsertContext();
	const title = formatMessage(templateGalleryMessages.templateGalleryTitle);
	const onSelect = useCallback(
		({ editorView }: OnSelectContext) => {
			openTemplateGallerySafely(onOpenTemplateGallery);
			return editorView.state.tr;
		},
		[onOpenTemplateGallery],
	);

	return (
		<QuickInsertMenuItem
			description={formatMessage(templateGalleryMessages.templateGalleryDescription)}
			iconBefore={<TemplateIcon label={title} />}
			isDisabled={isOffline}
			onSelect={onSelect}
			title={title}
		/>
	);
};
